export default __webpack_public_path__ + "static/media/img-ltsh-8-2.a8f4d42d.png";